<template>
    <div>
        <social-sharing
            :url="url"
            :title="title"
            :quote="title"
            :description="description"
            inline-template>
            <div class="tw-flex tw-gap-4 tw-justify-center">
                <network network="facebook">
                    <img class="tw-cursor-pointer" width="40px" height="40px"
                         src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-facebook.png">
                </network>
                <div>
                    <a href="https://www.instagram.com/leiloesjudiciais.com.br?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <img class="tw-cursor-pointer" width="40px" height="40px"
                             src="https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/geral/imagens/icon-instagram.png"
                             alt="instagram">
                    </a>
                </div>
                <network network="whatsapp">
                    <img class="tw-cursor-pointer" width="40px" height="40px"
                         src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-whats.png">
                </network>
                <network network="email">
                    <img class="tw-cursor-pointer" width="40px" height="40px"
                         src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-mail.png">
                </network>
            </div>
        </social-sharing>
    </div>
</template>

<script>
export default {
    name: "LeilaoSocial",
    props: ['title', 'description', 'image', 'url']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/social/LeilaoSocial.vue